import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { ICategoryContentCard } from '@models/ICategoryContentCard';
import truncateText from '@utils/helpers/truncateText';
import useMediaQuery from '@utils/hooks/useMediaQuery';

interface Props extends ICategoryContentCard {
  readonly isLargeCard: boolean;
  readonly dataTestId?: string;
}

const CategoryContentCard = ({
  dataTestId = 'Category-Content-Card',
  title,
  text,
  link,
  image,
  isLargeCard,
}: Props) => {
  const isMobile = useMediaQuery(1024);

  return (
    <div
      className="rounded-[5px] bg-grey-200 lg:flex lg:h-full lg:flex-col lg:rounded-[10px] dark:bg-grey-600"
      data-testid={dataTestId}
    >
      <div className="px-2.5 pt-2.5">
        <Image
          image={image}
          imageClasses={`object-cover lg:aspect-[8/3] ${
            isLargeCard ? 'aspect-3/2' : 'aspect-[2/1]'
          }`}
          dataTestId={`${dataTestId}-Image`}
        />
      </div>

      <div
        className={`lg:flex lg:h-full lg:flex-col ${
          isLargeCard
            ? 'py-7.5 pr-[25px] pl-7.5 lg:px-7.5'
            : 'px-7.5 pt-[25px] pb-7.5 lg:p-7.5'
        }`}
      >
        <p
          className={isMobile ? 'h6 mb-[5px]' : 'h5 mb-2.5'}
          data-testid={`${dataTestId}-Title`}
        >
          {title}
        </p>

        <div className="lg:flex lg:grow lg:flex-col lg:justify-between">
          <p
            className={`${
              isMobile ? 'body-three' : 'body-two'
            } mb-7.5 w-full text-grey-450 lg:mb-10 dark:text-grey-400 ${
              isLargeCard ? 'lg:w-3/5' : 'lg:w-9/12'
            }`}
            data-testid={`${dataTestId}-Text`}
          >
            {text.length > 90 ? truncateText(text, 90, '...') : text}
          </p>
          {link?.name && link.url && (
            <Button
              link={link}
              className="self-start"
              dataTestId={`${dataTestId}-Link`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryContentCard;
